import type { Attribute, AttributeGroup, CategoryProductSchema, ID } from "@/lib/catalog/types";
import { getAttributeGroupById } from "@/lib/catalog/attributeGroupsStore";
import { getCatalogAttributeById } from "@/lib/catalog/catalogAttributesStore";
import type { CatalogAttributeRecord } from "@/lib/catalog/catalogAttributesStore";
import { getCategoryById } from "@/lib/catalog/categoriesStore";
import { listLinksForCategory } from "@/lib/catalog/categoryAttributeLinksStore";

function toSchemaAttribute(r: CatalogAttributeRecord): Attribute {
  const { attributeGroupId, createdAt, ...rest } = r;
  void attributeGroupId;
  void createdAt;
  return rest;
}

export function buildCategoryProductSchema(categoryId: ID): CategoryProductSchema | null {
  const category = getCategoryById(categoryId);
  if (!category) return null;

  const links = listLinksForCategory(categoryId);
  const groupOrder: ID[] = [];
  const attrsByGroup = new Map<ID, Attribute[]>();

  for (const link of links) {
    const rec = getCatalogAttributeById(link.attributeId);
    if (!rec) continue;
    const gid = rec.attributeGroupId;
    if (!attrsByGroup.has(gid)) {
      groupOrder.push(gid);
      attrsByGroup.set(gid, []);
    }
    const list = attrsByGroup.get(gid)!;
    if (!list.some((a) => a.id === rec.id)) list.push(toSchemaAttribute(rec));
  }

  const groups: AttributeGroup[] = [];
  for (const gid of groupOrder) {
    const g = getAttributeGroupById(gid);
    if (!g) continue;
    groups.push({
      id: g.id,
      name: g.name,
      slug: g.slug,
      description: g.description ?? null,
      sortOrder: g.sortOrder,
      attributes: attrsByGroup.get(gid) ?? [],
    });
  }

  return {
    category: { id: category.id, name: category.name, parentId: category.parentId },
    groups,
  };
}
